import React,{useState, useEffect} from 'react';

import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Juserfunc(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
  <title>Java user defined function tutorial For Beginners</title>
<meta name="description" content="Java user defined function tutorial for beginners.Program can define its own function and a function consist of the following." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java user defined function,user defined function in java
,user defined function in javascript,java user defined functions,spark sql user defined function java,user-defined function on java,how to write user defined function in java" />
<link rel="canonical" href="https://www.codeexampler.com/java-user-defined-function" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">User define a function in java</h1>
    <div className="first">
        <a href="/java-method">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-object-initialize">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para ">The Program can define its own function and a function consist of the following.
    </p>
    <h2 className="mt-4 mh2">There are 5 types of user define function in java:
</h2>
<h3 className="mt-4 mh3">1, Function prototype(declaration)<br/>
2, Function definition<br/>
3, Calling function (accessing)<br/>
4, Function argument(parameter)<br/>
5, Return value by the function<br/>
</h3>



<h2 className="headings">Q-Write a Program user define function in java example?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-7">public </span>
              
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> school</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">hello</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"hello function"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}   
              
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-1">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"this is a function programme"</span>
              <span className="qwerty-1">);</span>
              {"\n"}  
              <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;hello</span>
              <span className="qwerty-1">();</span>
              <span className="qwerty-5">{`// calling function  `}</span>

              {"\n"}   
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"hello is a function"</span>
              <span className="qwerty-1">);</span>
              {"\n"} 
        <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"} {"\n"}
        </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;this is a function program</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;hello function</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;hello is a function</span>
              {"\n"} 
                </code>{"   "}
                </pre>
          </div>
        </div>     




<h2 className="headings">Q-What will be the output of the following function Program when a person goes from the USA and stay in the UK and create a plane to travel to India?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            
              {"\n"}
              <span className="qwerty-7">public </span>
              
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> a</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">USA</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"hello function"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">Uk</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}

              <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;USA</span>
              <span className="qwerty-1">();</span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"UK journey"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}
              {"\n"}{"\n"}   
              
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"travel start"</span>
              <span className="qwerty-1">);</span>
              {"\n"}  
              <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Uk</span>
              <span className="qwerty-1">();</span>

              {"\n"}   
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"India journey"</span>
              <span className="qwerty-1">);</span>
              {"\n"} 
        
        
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"} {"\n"}
        
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;travel</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;USA journey</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;UK journey</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;India journey</span>
              {"\n"} 
                </code>{"   "}
                </pre>
          </div>
        </div>


  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/java-method">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-object-initialize">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Juserfunc;